import {
  WandSparkles, FilePlus, Database, FileText, Truck
} from 'lucide-react'

export const PURCHASES_QUICK_MENU_ITEMS = [
  { label: 'Compra Inteligente', path: '/erp/purchases/intelligence', icon: WandSparkles, color: 'bg-emerald-600' },
  { label: 'Nova Requisição', path: '/erp/purchases/new-request', icon: FilePlus, color: 'bg-emerald-600' },
  { label: 'Estoque Mínimo', path: '/erp/purchases/minimum-stock', icon: Database, color: 'bg-blue-600' },
  { label: 'Rascunhos', path: '/erp/purchases/draft-list', icon: FileText, color: 'bg-slate-600' },
  { label: 'Pipeline Compras', path: '/erp/purchases', icon: Truck, color: 'bg-indigo-600' }
]
